import React from "react";

function CollageFooter() {
  return (
    <div className="hero-text-section hero-text-hide">
      <p className="hero-footer">BELIEF Led Us Here, PASSION Built It</p>
    </div>
  );
}

export default CollageFooter;
